import styles from "~/pages/blog/blog-index.module.scss";
import ArticleCard from "~/components/Blog/ArticleCard";
import Layout from "~/components/layouts/Blog";
import Pagination from "~/components/Blog/Pagination";
import {} from "~/utils/Blog/Post";
import Head from "~/components/Meta/Head";
import { blog as blogConfig, exclude_filter } from "~/config/blog";
import { getPosts, getFeaturedPosts } from "~/utils/Blog/Post";
import { getPage } from "~/utils/Blog/Page";
import { FetchError } from "~/utils/Fetch/json";
import API from "~/config/api";
import { getIronSession } from "iron-session";
import { sessionOptions } from "~/config/session";
import { validate_user } from "~/utils/authServer";
import CTA from "~/components/Common/CTA";
import { BLOG_FUNNEL } from "~/config/funnel";

const Page = ({ page, ghost, featured, page_num }) => {
  return (
    <>
      <Head
        title={page?.meta_title}
        description={page?.meta_description}
        socialImageUrl={page?.og_image || page?.twitter_image}
        url={`${process.env.CLIENT_ORIGIN}${blogConfig.baseUrl}page/${page_num}`}
      />
      <div className={styles["blog-index"]}>
        <div className={styles["blog-index__container"]}>
          <main className={styles["blog-index__main"]}>
            {ghost.posts.map((post, key) => {
              return <ArticleCard post={post} key={key} />;
            })}
            <div className={styles["--full-width"]}>
              {ghost?.meta?.pagination?.total > 0 && (
                <Pagination pagination={ghost.meta.pagination} />
              )}
            </div>
          </main>
          <aside className={styles["blog-index__sidebar"]}>
            <div className={styles["blog-index__sidebar-container"]}>
              <div className={styles["blog-index__cta-container"]}>
                <CTA page={"blog"} funnel={BLOG_FUNNEL} />
              </div>
              <div className={styles["blog-index__sidebar-heading"]}>
                Featured Blog Posts
              </div>
              {featured.posts.map((post, key) => {
                return <ArticleCard minimal={true} post={post} key={key} />;
              })}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
};

Page.getLayout = function getLayout(page) {
  return <Layout {...page.props}>{page}</Layout>;
};

export const getServerSideProps = async ({ req, res, params }) => {
    const { page } = params;
    const page_decode = Number(decodeURI(page));
    const has_brackets_regex = new RegExp(/^[\[\]]/);
    if (page_decode == 1) {
      return {
        redirect: {
          destination: blogConfig.baseUrl,
          permanent: true,
        },
      };
    } else if (
      has_brackets_regex.test(decodeURI(page)) ||
      [undefined, null, NaN].includes(page_decode)
    ) {
      return {
        props: { statusCode: 404 },
        notFound: true,
      };
    }
    try {
      const session = await getIronSession(req, res, sessionOptions);
      let hide_tags = true;

      if (session.auth) {
        const user_auth = await validate_user(req, res, API.Auth.validate({}));
        if (user_auth?.isLoggedIn && user_auth?.user?.is_prime) {
          hide_tags = false;
        }
      }

      let filters = hide_tags ? exclude_filter() : null;

      const [posts_res, featured_res, page_res] = await Promise.all([
        getPosts({ page: page_decode, filters }),
        getFeaturedPosts({}),
        getPage({ slug: "blog" }),
      ]);

      const [ghost, featured, page_data] = await Promise.all([
        posts_res.data,
        featured_res.data,
        page_res.data.pages[0],
      ]);

      if (ghost.posts.length <= 0) {
        return {
          props: { statusCode: 404 },
          notFound: true,
        };
      }

      return {
        props: {
          ghost,
          featured,
          page: page_data,
          blog_hide_tags: hide_tags,
          page_num: page_decode,
        },
      };
    } catch (error) {
      if (
        error instanceof FetchError &&
        (error.response.status === 404 || error.response.status == 422)
      ) {
        return {
          props: { statusCode: 404 },
          notFound: true,
        };
      } else {
        throw error; // let others bubble up
      }
    }
};

export default Page;
